// 剪辑池草稿持久化：基于 IndexedDB，按「用户 + 标签页」分槽位存储，
// 避免多个窗口同时剪辑时草稿互相覆盖。草稿最长保留 24 小时，过期惰性清理。
const DB_NAME = 'clip_pool'
const STORE_NAME = 'drafts'
const DB_VERSION = 1
const DRAFT_TTL = 24 * 60 * 60 * 1000

let dbPromise = null

function openDb() {
  if (dbPromise) return dbPromise
  dbPromise = new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)
    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'draftKey' })
      }
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
  return dbPromise
}

// 标签页唯一标识：同标签页刷新保持不变，新开标签页生成新 id
function getTabId() {
  const KEY = 'clip_pool_tab_id'
  let id = sessionStorage.getItem(KEY)
  if (!id) {
    id = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : (Math.random().toString(36).slice(2) + Date.now().toString(36))
    sessionStorage.setItem(KEY, id)
  }
  return id
}

function getUserId() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    return String(user.phoneNumber || user.id || 'guest')
  } catch (e) {
    return 'guest'
  }
}

function getDraftKey() {
  return `${getUserId()}:${getTabId()}`
}

async function saveDraft(data) {
  try {
    const db = await openDb()
    // 深度序列化为纯对象，避免 Vue 响应式 Proxy 无法被 IndexedDB 结构化克隆
    const draft = JSON.parse(JSON.stringify({
      draftKey: getDraftKey(),
      userId: getUserId(),
      tabId: getTabId(),
      savedAt: Date.now(),
      ...data
    }))
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite')
      tx.objectStore(STORE_NAME).put(draft)
      tx.oncomplete = () => resolve()
      tx.onerror = () => reject(tx.error)
      tx.onabort = () => reject(tx.error)
    })
  } catch (e) {
    // 草稿保存失败不影响剪辑流程
    console.error('[poolDraft] saveDraft failed', e)
  }
}

// 列出当前用户所有未过期草稿（按保存时间倒序），并顺带清理过期记录
async function listDrafts() {
  try {
    const db = await openDb()
    const all = await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly')
      const req = tx.objectStore(STORE_NAME).getAll()
      req.onsuccess = () => resolve(req.result || [])
      req.onerror = () => reject(req.error)
    })

    const now = Date.now()
    const userId = getUserId()
    const valid = []
    const expiredKeys = []

    all.forEach(d => {
      if (d.userId !== userId) return
      if (!d.savedAt || now - d.savedAt > DRAFT_TTL) {
        expiredKeys.push(d.draftKey)
      } else {
        valid.push(d)
      }
    })

    if (expiredKeys.length > 0) {
      const tx = db.transaction(STORE_NAME, 'readwrite')
      const store = tx.objectStore(STORE_NAME)
      expiredKeys.forEach(key => store.delete(key))
    }

    valid.sort((a, b) => (b.savedAt || 0) - (a.savedAt || 0))
    return valid
  } catch (e) {
    console.error('[poolDraft] listDrafts failed', e)
    return []
  }
}

async function clearDraft(draftKey) {
  try {
    const db = await openDb()
    const key = draftKey || getDraftKey()
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite')
      tx.objectStore(STORE_NAME).delete(key)
      tx.oncomplete = () => resolve()
      tx.onerror = () => reject(tx.error)
      tx.onabort = () => reject(tx.error)
    })
  } catch (e) {
    console.error('[poolDraft] clearDraft failed', e)
  }
}

export { saveDraft, listDrafts, clearDraft, getDraftKey, getTabId, getUserId }
